import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/products/server',
    name: 'Server',
    component: () => import('../views/products/Server.vue')
  },
  {
    path: '/products/storage',
    name: 'Storage',
    component: () => import('../views/products/Storage.vue')
  },
  {
    path: '/products/innovation',
    name: 'Innovation',
    component: () => import('../views/products/Innovation.vue')
  },
  {
    path: '/products/xsky',
    name: 'XSKY',
    component: () => import('../views/products/XSKY.vue')
  },
  {
    path: '/products/xsky/xeos',
    name: 'XEOS',
    component: () => import('../views/products/detail/XEOS.vue')
  },
  {
    path: '/products/xsky/xebs',
    name: 'XEBS',
    component: () => import('../views/products/detail/XEBS.vue')
  },
  {
    path: '/products/xsky/xgfs',
    name: 'XGFS',
    component: () => import('../views/products/detail/XGFS.vue')
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('../views/Solutions.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/products/server/nf5280m6',
    name: 'ServerNF5280M6',
    component: () => import('../views/products/detail/NF5280M6.vue')
  },
  {
    path: '/products/server/nf5270m6',
    name: 'ServerNF5270M6',
    component: () => import('../views/products/detail/NF5270M6.vue')
  },
  {
    path: '/products/server/nf5468m6',
    name: 'ServerNF5468M6',
    component: () => import('../views/products/detail/NF5468M6.vue')
  },
  {
    path: '/products/server/nf5280m5',
    name: 'ServerNF5280M5',
    component: () => import('../views/products/detail/NF5280M5.vue')
  },
  {
    path: '/products/server/nf8480m6',
    name: 'ServerNF8480M6',
    component: () => import('../views/products/detail/NF8480M6.vue')
  },
  {
    path: '/products/server/nf5468g7',
    name: 'ServerNF5468G7',
    component: () => import('../views/products/detail/NF5468G7.vue')
  },
  {
    path: '/products/lenovo/wa5480g3',
    name: 'LenovoWA5480G3',
    component: () => import('../views/products/detail/wa5480g3.vue')
  },
  {
    path: '/products/lenovo',
    name: 'Lenovo',
    component: () => import('../views/products/Lenovo.vue')
  },
  {
    path: '/products/lenovo/sr650v3',
    name: 'LenovoSR650V3',
    component: () => import('../views/products/detail/sr650v3.vue')
  },
  {
    path: '/products/innovation/cs5280h2',
    name: 'InnovationCS5280H2',
    component: () => import('../views/products/detail/CS5280H2.vue')
  },
  {
    path: '/products/innovation/cs5260h2',
    name: 'InnovationCS5260H2',
    component: () => import('../views/products/detail/CS5260H2.vue')
  },
  {
    path: '/products/innovation/cs5280f3',
    name: 'InnovationCS5280F3',
    component: () => import('../views/products/detail/CS5280F3.vue')
  },
  {
    path: '/products/innovation/nf5468h7',
    name: 'InnovationNF5468H7',
    component: () => import('../views/products/detail/NF5468H7.vue')
  },
  {
    path: '/products/innovation/cs5280h3',
    name: 'InnovationCS5280H3',
    component: () => import('../views/products/detail/CS5280H3.vue')
  },
  {
    path: '/products/innovation/cs5468h3',
    name: 'InnovationCS5468H3',
    component: () => import('../views/products/detail/CS5468H3.vue')
  },
  {
    path: '/products/innovation/cs5280k2',
    name: 'InnovationCS5280K2',
    component: () => import('../views/products/detail/CS5280K2.vue')
  },
  {
    path: '/products/storage/as2150g2',
    name: 'StorageAS2150G2',
    component: () => import('../views/products/detail/AS2150G2.vue')
  },
  {
    path: '/products/storage/as2200g2',
    name: 'StorageAS2200G2',
    component: () => import('../views/products/detail/AS2200G2.vue')
  },
  {
    path: '/products/storage/as2600g2',
    name: 'StorageAS2600G2',
    component: () => import('../views/products/detail/AS2600G2.vue')
  },
  {
    path: '/products/storage/as5300g5',
    name: 'StorageAS5300G5',
    component: () => import('../views/products/detail/AS5300G5.vue')
  },
  {
    path: '/products/storage/as5500g5',
    name: 'StorageAS5500G5',
    component: () => import('../views/products/detail/AS5500G5.vue')
  },
  {
    path: '/products/storage/hf5000g5',
    name: 'StorageHF5000G5',
    component: () => import('../views/products/detail/HF5000G5.vue')
  },
  {
    path: '/products/storage/hf2000g7',
    name: 'StorageHF2000G7',
    component: () => import('../views/products/detail/HF2000G7.vue')
  },
  {
    path: '/products/storage/hf3000g7',
    name: 'StorageHF3000G7',
    component: () => import('../views/products/detail/HF3000G7.vue')
  },
  {
    path: '/solutions/enterprise',
    name: 'EnterpriseSolution',
    component: () => import('../views/solutions/Enterprise.vue')
  },
  {
    path: '/solutions/deepseek',
    name: 'DeepseekSolution',
    component: () => import('../views/solutions/Deepseek.vue')
  },
  {
    path: '/solutions/business',
    name: 'BusinessSolution',
    component: () => import('../views/solutions/Business.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
